module.exports = __webpack_public_path__ + "img/honor10.f6198372.png";